module.exports = __webpack_public_path__ + "img/27.225e3742.png";